<template>
  <div class="content">
    <Loader :loadType="1" v-show="isShowLoader" class="black" style="top:-55px;"></Loader>
    <div class="header">
      <h1>发票管理<span>可开票金额：¥ {{(userInfo.statistics.invoiceable || 0) | amountThousands}}</span></h1>
      <div class="stat">
        <div class="stat_wrap">
          <div class="stat_wrap_content">
            <span class="title">发票金额：</span>
            <Input type="text" v-model.trim="form.amount" placeholder="请输入您需要开票的金额"></Input>
            <span class="title">开票信息：</span>
            <div class="title_input">
              <Input type="text" v-model.trim="form.title" placeholder="请输入您要开票的发票抬头"></Input>
              <div class="select_more" v-if="books.length > 0" @click.stop.prevent="isShowAddrDropbox=!isShowAddrDropbox"><img src="@/assets/images/icons/member/icon_more.png"></div>
              <ul class="select_books" v-if="isShowAddrDropbox && !isShowModal">
                <li v-for="item in books" :key="item.id" @click.stop.prevent="select_book_item($event, item.id)">{{ item.title }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="invoice-btn" @click.prevent="isShowModal=true">申请开票</div>
      </div>
    </div>
    <div class="table_content">
      <span v-if="userInfo.statistics.invoice > 0" class="expire_jf">已开票：¥ {{(userInfo.statistics.invoice || 0) | amountThousands}}</span>
      <Tabs value="list">
        <TabPane label="开票记录" name="list">
          <Table :columns="columns" :data="list" :loading="loaderQuery" no-data-text="暂无开票记录"></Table>
          <Page :total="total" :page-size="pageSize" size="small" @on-change="getList" v-if="total > pageSize"></Page>
        </TabPane>
      </Tabs>
    </div>
    <Modal v-model="isShowModal" class="accountModalBox invoiceModalBox" @on-cancel="cancelHandle" :mask-closable="false" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content">
        <div class="modal-content-wrap">
          <div class="header">申请开票</div>
          <Form ref="form" :model="form" :rules="ruleForm" @submit.native.prevent>
            <FormItem prop="amount">
              <i class="form-icon2 amount"></i>
              <Input type="text" v-model.trim="form.amount" @on-enter="ok" :placeholder="$t('account.invoice.amountPlaceholder')" />
            </FormItem>
            <FormItem prop="vat">
              <i class="form-icon2 vat"></i>
              <Select v-model.trim="form.vat" :placeholder="$t('account.invoice.vatPlaceholder')" @on-change="selectVat">
                <Option v-for="(option, index) in $options.filters.getInvoiceVat()" :value="option.value" :key="index">{{option.name}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="type">
              <i class="form-icon2 type"></i>
              <Select v-model.trim="form.type" :placeholder="$t('account.invoice.typePlaceholder')" @on-change="selectType">
                <Option v-for="(option, index) in invoiceType" :value="option.value" :key="index">{{option.name}}</Option>
              </Select>
            </FormItem>
            <FormItem prop="title" class="title_input">
              <i class="form-icon2 title"></i>
              <Input type="text" v-model.trim="form.title" @on-change="change" @on-enter="ok" :placeholder="$t('account.invoice.titlePlaceholder')" />
              <div class="select_more" v-if="books.length > 0" @click.stop.prevent="isShowAddrDropbox=!isShowAddrDropbox"><img src="@/assets/images/icons/member/icon_more.png"></div>
              <ul class="select_books" v-if="isShowAddrDropbox && isShowModal">
                <li v-for="item in books" :key="item.id" @click.stop.prevent="select_book_item($event, item.id)">{{item.title}}</li>
              </ul>
            </FormItem>
            <FormItem prop="taxNo" v-show="isShowField">
              <i class="form-icon2 taxNo"></i>
              <Input type="text" v-model.trim="form.taxNo" @on-change="change" @on-enter="ok" :placeholder="$t('account.invoice.taxNoPlaceholder')" />
            </FormItem>
            <FormItem prop="address" v-show="isShowField">
              <i class="form-icon2 address"></i>
              <Input type="text" v-model.trim="form.address" @on-change="change" @on-enter="ok" :placeholder="$t('account.invoice.addressPlaceholder')" />
            </FormItem>
            <FormItem prop="mobile" v-show="isShowField">
              <i class="form-icon2 mobile"></i>
              <Input type="text" v-model.trim="form.mobile" @on-change="change" @on-enter="ok" :placeholder="$t('account.invoice.mobilePlaceholder')" />
            </FormItem>
            <FormItem prop="bank" v-show="isShowField">
              <i class="form-icon2 bank"></i>
              <Input type="text" v-model.trim="form.bank" @on-change="change" @on-enter="ok" :placeholder="$t('account.invoice.bankPlaceholder')" />
            </FormItem>
            <FormItem prop="bankNo" v-show="isShowField">
              <i class="form-icon2 bankNo"></i>
              <Input type="text" v-model.trim="form.bankNo" @on-change="change" @on-enter="ok" :placeholder="$t('account.invoice.bankNoPlaceholder')" />
            </FormItem>
          </Form>
          <div class="footer">
            <Button type="primary" :loading="isShowModalLoader" @click="ok">
              <span v-if="!isShowModalLoader"><span>申请开票</span></span>
              <span v-else>申请开票</span>
            </Button>
          </div>
          <Loader :loadType="1" v-show="isShowModalLoader" class="black"></Loader>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import Loader from '@/components/layout/Loader'

export default {
  name: 'MyInvoiceContent',
  components: { Loader },
  data () {
    const amountCheck = (rule, value, callback) => {
      value = this._.trim(value)
      if (!value || !this.$options.filters.isPrice(value)) {
        return callback(new Error(this.$t('account.invoice.amountMsg')))
      } else {
        callback()
      }
    }
    const fieldValueCheck = (rule, value, callback) => {
      if (this.form.vat === 1 && this.form.type === 2) {
        callback()
      } else if (!value) {
        return callback(new Error(this.$t(`account.invoice.${rule.field}Msg`)))
      } else {
        callback()
      }
    }
    const isEmptyCheck = (rule, value, callback) => {
      if (value) {
        callback()
      } else {
        return callback(new Error(this.$t(`account.invoice.${rule.field}Msg`)))
      }
    }
    return {
      isSubmit: false,
      isShowLoader: false,
      loaderQuery: false,
      isShowModal: false,
      isShowModalLoader: false,
      isShowField: true,
      isShowAddrDropbox: false,
      id: null,
      books: [],
      form: {
        amount: null,
        vat: null,
        type: null,
        title: null,
        taxNo: null,
        address: null,
        mobile: null,
        bank: null,
        bankNo: null
      },
      ruleForm: {
        amount: [
          { required: true, message: this.$t('account.invoice.amountMsg'), trigger: 'blur' },
          { validator: amountCheck, trigger: 'blur' }
        ],
        vat: [{ validator: isEmptyCheck, trigger: 'change' }],
        type: [{ validator: isEmptyCheck, trigger: 'change' }],
        title: [{ validator: fieldValueCheck, trigger: 'blur' }],
        taxNo: [{ validator: fieldValueCheck, trigger: 'blur' }],
        address: [{ validator: fieldValueCheck, trigger: 'blur' }],
        mobile: [{ validator: fieldValueCheck, trigger: 'blur' }],
        bank: [{ validator: fieldValueCheck, trigger: 'blur' }],
        bankNo: [{ validator: fieldValueCheck, trigger: 'blur' }]
      },
      total: 0,
      pageSize: 8,
      userInfo: { statistics: {} },
      columns: [
        {
          title: '增值税类型',
          key: 'vat',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.getInvoiceVat(params.row.vat).name || '-')
          }
        },
        {
          title: '发票类型',
          key: 'type',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.getInvoiceType(params.row.type).name || '-')
          }
        },
        {
          title: '发票金额（元）',
          key: 'amount',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.amountThousands(params.row.amount || 0) || '-')
          }
        },
        {
          title: '发票抬头',
          key: 'title',
          align: 'center'
        },
        {
          title: '税号',
          key: 'taxNo',
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.taxNo || '-')
          }
        },
        {
          title: '快递信息',
          key: 'express',
          align: 'center',
          render: (h, params) => {
            return h('span', {
              attrs: {
                title: params.row.express ? params.row.express + ' ' + params.row.expressNo : ''
              }
            }, params.row.express ? (params.row.express + ' ' + params.row.expressNo) : '-')
          }
        },
        {
          title: '状态',
          key: 'status',
          align: 'center',
          render: (h, params) => {
            let statusItem = this.$options.filters.getInvoiceStatus(params.row.status)
            return h('span', {
              class: `invoice-status ${statusItem.className}`
            }, statusItem.name || '-')
          }
        },
        {
          title: '开票时间',
          key: 'createTime',
          align: 'center',
          render: (h, params) => {
            return h('span', this.$options.filters.dataFormat(params.row.createTime, 'dateTime.f1'))
          }
        }
      ],
      list: []
    }
  },
  computed: {
    invoiceType () {
      if (this.form.vat === 2) {
        return this._.filter(this.$options.filters.getInvoiceType(), o => o.value !== 2)
      } else {
        return this.$options.filters.getInvoiceType()
      }
    }
  },
  watch: {
    isShowModal (newVal, oldVal) {
      this.isShowAddrDropbox = false
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getUserInfo()
      this.getInvoiceBook()
      this.getList()
      this.$root.$on('clearFormCloseModal', () => {
        this.$refs['form'] && this.$refs['form'].resetFields()
      })
    })
  },
  methods: {
    select_book_item (event, id) {
      this.isShowAddrDropbox = false
      let item = this._.find(this.books, o => parseInt(o.id) === parseInt(id))
      if (item) {
        this.id = item.id
        this.form = Object.assign(this.form, {
          title: item.title,
          taxNo: item.taxNo,
          address: item.address,
          mobile: item.mobile,
          bank: item.bank,
          bankNo: item.bankNo
        })
      } else {
        this.id = null
      }
    },
    change () {
      this.id = null
    },
    selectVat (value) {
      if (value === 2 && this.form.type === 2) {
        this.form.type = null
      }
      this.isShowField = !(value === 1 && this.form.type === 2)
    },
    selectType (value) {
      this.isShowField = !(value === 2 && this.form.vat === 1)
    },
    cancelHandle (event) {
      this.$root.$emit('clearFormCloseModal', event)
    },
    ok () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (!this.isSubmit) {
            this.$Loading.start()
            this.isSubmit = true
            this.isShowModalLoader = true
            let _formData = {}
            if (this.form.vat === 1 && this.form.type === 2) {
              _formData = { amount: this.form.amount, type: this.form.type, vat: this.form.vat, title: this.form.title || '' }
            } else {
              if (this.id) {
                _formData = { amount: this.form.amount, type: this.form.type, vat: this.form.vat, id: this.id }
              } else {
                _formData = Object.assign({}, this.form)
              }
            }
            this.$api.account.member.invoice.applyInvoice(_formData, {
              success: response => {
                this.$Loading.finish()
                this.isSubmit = false
                this.isShowModalLoader = false
                if (response.data.code === 200) {
                  let that = this
                  this.$Message.success({
                    content: '操作成功',
                    duration: 0.5,
                    closable: true,
                    onClose () {
                      that.isShowModal = false
                      that.$root.$emit('clearFormCloseModal', event)
                      that.getUserInfo()
                      that.getInvoiceBook()
                      that.getList()
                    }
                  })
                } else if (response.data.code === 202100) {
                  this.$Message.warning({content: '发票金额少于最低开票金额', closable: true})
                } else if (response.data.code === 202101) {
                  this.$Message.warning({content: '可开票余额不足', closable: true})
                } else {
                  this.$Message.warning({content: this.$t('common.codeError'), closable: true})
                }
              },
              error: errorMsg => {
                this.$Loading.error()
                this.isSubmit = false
                this.isShowModalLoader = false
                this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
              }
            })
          }
        }
      })
    },
    getUserInfo () {
      if (this.isShowLoader) return
      this.$Loading.start()
      this.isShowLoader = true
      this.$api.account.member.home({
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.userInfo = response.data.data || { statistics: {} }
            if (!this.userInfo['statistics']) this.userInfo['statistics'] = {}
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    getInvoiceBook () {
      this.$api.account.member.invoice.book({
        success: (response) => {
          if (response.data.code === 200) {
            this.books = response.data.data
          }
        }
      })
    },
    getList (page = 1) {
      if (this.loaderQuery) return
      this.$Loading.start()
      this.loaderQuery = true
      this.$api.account.member.invoice.list({ page: page, size: this.pageSize }, {
        success: (response) => {
          this.$Loading.finish()
          if (response.data.code === 200) {
            this.list = response.data.data.result || []
            this.total = response.data.data.count || 0
          } else {
            this.$Message.warning({content: this.$t('common.codeError'), closable: true})
          }
          this.loaderQuery = false
        },
        error: (errorMsg) => {
          this.loaderQuery = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    }
  }
}
</script>
<style>
.invoiceModalBox form .ivu-select .ivu-select-input,
.invoiceModalBox form .ivu-input{
  padding-left: 28px;
}
</style>
<style scoped>
.table_content{
  position: relative;
  background-color: #fff;
  padding: 18px 22px 32px;
}
.expire_jf{
  font-size: 12px;
  color: #999;
  position: absolute;
  top: 28px;
  right: 26px;
  z-index: 1;
}
.content .header .stat .title_input{
  position: relative;
  margin-right: 30px;
}
.content .header .stat .title_input >>> .ivu-input{
  padding-right: 35px;
  margin-left: 0;
  margin-right: 0;
}
.content .header .stat .title_input li{
  padding-top: 5px;
  padding-bottom: 5px;
}
.select_more{
  position: absolute;
  right: 0px;
  width: 26px;
  top: 1px;
  bottom: 1px;
  cursor: pointer;
}
.select_more img{
  position: absolute;
  width: 18px;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
}
.select_books{
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  z-index: 100;
  border: 1px solid #e8e8e8;
  padding: 8px 0;
  background-color: #fff;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
}
.select_books li{
  cursor: pointer;
  padding: 0 12px;
  font-size: 14px;
  /*border-bottom: 1px solid #f5f4f4;*/
}
.select_books li:hover{
  background-color: #f5f4f4;
}
.select_books li:last-child{
  border-bottom: 0 none;
}
.ivu-form-item >>> .ivu-select .ivu-select-selection{
  padding-left: 19px;
  border-width: 0.5px;
}
.form-icon2{
  background: url("~@/assets/images/icons/member/icon_fpje.png") 0 0 no-repeat transparent;
  width: 13px;
  height: 13px;
  background-size: auto 13px;
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
}
.form-icon2.vat{
  background-image: url("~@/assets/images/icons/member/icon_zzslx.png");
  width: 12px;
  height: 12px;
  background-size: auto 12px;
  margin-top: 1px;
}
.form-icon2.type{
  background-image: url("~@/assets/images/icons/member/icon_fplx.png");
  width: 11px;
  height: 11px;
  background-size: auto 11px;
  margin-top: 1px;
}
.form-icon2.title{
  background-image: url("~@/assets/images/icons/member/icon_fptt.png");
}
.form-icon2.taxNo{
  background-image: url("~@/assets/images/icons/member/icon_sh.png");
  background-size: 13px auto;
  margin-top: 2px;
}
.form-icon2.address{
  background-image: url("~@/assets/images/icons/member/icon_fpdz.png");
  width: 11px;
  height: 15px;
  background-size: 11px auto;
  margin-top: 2px;
}
.form-icon2.mobile{
  background-image: url("~@/assets/images/icons/member/icon_dh.png");
  margin-top: 1px;
}
.form-icon2.bank{
  background-image: url("~@/assets/images/icons/member/icon_khh.png");
  margin-top: 1px;
}
.form-icon2.bankNo{
  background-image: url("~@/assets/images/icons/member/icon_yhkh.png");
  background-size: 13px auto;
  margin-top: 2px;
}
.content{
  margin-bottom: 30px;
}
.content .header{
  border-bottom: 1px solid #E8E8E8;
  padding: 18px 22px 22px;
  margin-bottom: 15px;
  background-color: #fff;
}
.content .header h1{
  font-size: 16px;
  font-weight: normal;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}
.content .header h1 span{
  color: #999;
  font-size: 12px;
  padding-left: 30px;
}
.content .header .stat,
.content .header .stat .stat_wrap,
.stat_wrap_content{
  position: relative;
  display: flex;
  align-items: center;
}
.content .header .stat .title{
  color: #999;
  font-size: 12px;
  white-space: nowrap;
}
.content .header .stat >>> .ivu-input{
  width: 210px;
  margin-left: 5px;
  margin-right: 5px;
  border: 1px solid #DADADA;
  border-radius: 3px;
  height: 30px;
  line-height: 28px;
  padding: 0 5px;
  margin-right: 30px;
}
.content .header .stat >>> .ivu-input:focus{
  border-color: #57a3f3;
}
.content .header .stat .invoice-btn{
  cursor: pointer;
  border: 0 none;
  padding: 0;
  background-image: linear-gradient(90deg, #42BEFF 9%, #1F8AFD 100%);
  border-radius: 3px;
  height: 30px;
  line-height: 30px;
  width: 100px;
  font-size: 12px;
  text-align: center;
  color: #fff;
}
.content >>> .ivu-tabs-bar{
  border-bottom: 0 none;
  margin-bottom: 0;
}
.content >>> .ivu-tabs-nav .ivu-tabs-tab-active{
  color: #333;
  padding-bottom: 15px;
  padding-left: 1px;
}
.content >>> .ivu-tabs-ink-bar{
  /*background-color: #1F8AFD;*/
  display: none;
}
.content >>> .ivu-table-wrapper,
.content >>> .ivu-table th,
.content >>> .ivu-table td{
  border-color: #E8E8E8;
  font-weight: normal;
  font-size: 13px;
}
.content >>> .ivu-table-cell{
  color: #333;
}
.content >>> .ivu-table td.time .ivu-table-cell{
  color: #999;
}
.content >>> .ivu-spin-fix{
  border-color: #E8E8E8;
  background-color: rgba(255, 255, 255, .7);
}
.content >>> .ivu-table-tip{
  color: #999;
}
.content >>> tr.ivu-table-row-hover td{
  /* background-color: #edf8ff; */
}
.content >>> .ivu-page{
  margin: 25px 0 10px;
  text-align: center;
}
.content >>> .ivu-page.mini .ivu-page-item{
  border: 1px solid #EDEDED;
  margin: 0 3px;
}
.content >>> .ivu-page.mini .ivu-page-item a{
  color: #999;
  font-size: 13px;
}
.content >>> .ivu-page-item-active{
  background-color: #1F8AFD;
}
.content >>> .ivu-page.mini .ivu-page-item.ivu-page-item-active a{
  color: #fff;
}
.content >>> .invoice-status{
  color: #333;
}
.content >>> .invoice-status.doing{
  color: #1ECD7A;
}
.content >>> .invoice-status.success{
  color: #1F8AFD;
}
.content >>> .invoice-status.error{
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/components/member/zh-CN/invoice/Content.vue